module.exports = __webpack_public_path__ + "static/media/travnik.d081e2d2.jpg";